import {Injectable} from '@angular/core';
import {ImageService, OrdersService, ProleisObject,} from '@proleis/proleis-rest-client';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {exhaustMap, map, switchMap} from 'rxjs/operators';
import {OrdersActions} from './orders.index';
import {SuppliersService} from '../../../services/suppliers.service';
import {forkJoin, Observable, of} from 'rxjs';

@Injectable()
export class OrdersEffects {
  constructor(
    private actions: Actions,
    private ordersService: OrdersService,
    private suppliersService: SuppliersService,
    private imageService: ImageService,
  ) {
  }

  loadOrder$ = createEffect(() => {
    return this.actions.pipe(
      ofType(OrdersActions.LOAD_ORDER),
      switchMap((action) => {
        const aliasFields =
          'LIEFERANT=FIRMA_ID.NAME;AUFTRAG=AUFTRAG_ID.NAME;LIEFERSTATUS=FREIGABE_ID.DESCRIPTION;BEZUG=LINK_ID.NAME;' +
          'LIEFERSTATUS_ICON=FREIGABE_ID.ICON;PROJEKTNAME=LINK_ID.PARENTANDMYSELF[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84].TEXT' +
          ';CHANNELNAME=CHANNEL_ID.NAME;CHANNELGUID=CHANNEL_ID.GUID';
        return this.ordersService
          .getPurchaseOrder(action.orderId, aliasFields)
          .pipe(map((order) => OrdersActions.LOAD_ORDER_SUCCESS({order})));
      }),
    );
  });

  onLoadedOrder$ = createEffect(
    () => {
      return this.actions.pipe(ofType(OrdersActions.LOAD_ORDER_SUCCESS));
    },
    {dispatch: false},
  );

  onLoadedOrderError$ = createEffect(
    () => {
      return this.actions.pipe(ofType(OrdersActions.LOAD_ORDER_ERROR));
    },
    {dispatch: false},
  );

  loadOrders$ = createEffect(() => {
    return this.actions.pipe(
      ofType(OrdersActions.LOAD_ORDERS),
      exhaustMap((action) => {
        const aliasFields =
          'LIEFERANT=FIRMA_ID.NAME;AUFTRAG=AUFTRAG_ID.NAME;LIEFERSTATUS=FREIGABE_ID.DESCRIPTION;BEZUG=LINK_ID.NAME;' +
          'PROJEKTNAME=PROJEKT_OBJECT_ID.TEXT;CHANNELNAME=CHANNEL_ID.NAME;CHANNELGUID=CHANNEL_ID.GUID;FREIGABE_GUID=FREIGABE_ID.GUID';
        return this.ordersService
          .getPurchaseOrders(
            action.filterStart,
            action.filterEnd,
            action.filterAll,
            action.filterChannel,
            action.filterChanged,
            null,
            aliasFields,
          )
          .pipe(map((orders) => OrdersActions.LOAD_ORDERS_SUCCESS({orders})));
      }),
    );
  });

  onLoadedOrders$ = createEffect(
    () => {
      return this.actions.pipe(ofType(OrdersActions.LOAD_ORDERS_SUCCESS));
    },
    {dispatch: false},
  );

  onLoadedOrdersError$ = createEffect(
    () => {
      return this.actions.pipe(ofType(OrdersActions.LOAD_ORDERS_ERROR));
    },
    {dispatch: false},
  );

  loadChannels$ = createEffect(() => {
    return this.actions.pipe(
      ofType(OrdersActions.LOAD_CHANNELS),
      exhaustMap((action) => {
        return this.suppliersService
          .getChannels()
          .pipe(
            map((channels) =>
              OrdersActions.LOAD_CHANNELS_SUCCESS({channels}),
            ),
          );
      }),
    );
  });

  onLoadedChannels$ = createEffect(
    () => {
      return this.actions.pipe(ofType(OrdersActions.LOAD_CHANNELS_SUCCESS));
    },
    {dispatch: false},
  );

  onLoadedChannelsError$ = createEffect(
    () => {
      return this.actions.pipe(ofType(OrdersActions.LOAD_CHANNELS_ERROR));
    },
    {dispatch: false},
  );

  loadOverview$ = createEffect(() => {
    const aliasOrder =
      'LIEFERANT=FIRMA_ID.NAME;AUFTRAG=AUFTRAG_ID.NAME;LIEFERSTATUS=FREIGABE_ID.DESCRIPTION;BEZUG=LINK_ID.NAME;' +
      'PROJEKTNAME=PROJEKT_OBJECT_ID.TEXT;CHANNELNAME=CHANNEL_ID.NAME;CHANNELGUID=CHANNEL_ID.GUID';
    const aliasTp =
      'SNR=TEILE_OBJECT_ID.TEXT;ACTIVITYICON=PSETYP_ID.CLIENTICON;' +
      'TERMINA=PARENT.MEILENSTEIN_CONT_ID.CHILD[NAME=A-TER].MS_DATUM;CALC_OPEN=OBJECT_ID.CALC_COUNT_OPEN_DELIVERY' +
      ';WERKZEUGART=PSE_WERKZEUGART_ID.TEXT;AUSFUEHRUNG=PSE_AUSFUEHRUNG.DESCRIPTION;PSETYPGUID=PSETYP_ID.GUID' +
      ';DWS_CHANGE_DOCUNAME=DWS_CHANGE_DOCU_ID.NAME;' +
      'IS_OMITTED=$OR(PR_STATUS_ID.GUID="130e6902-2c07-11b2-80a4-1b2cfea31215",' +
      'PARENT.PR_STATUS_ID.GUID="130e6902-2c07-11b2-80a4-1b2cfea31215");';
    const aliasPm =
      'PMGROUP=LINK_ID.PM_GROUP_ID.TEXT;PROJECTNAME=LINK_ID.PM_LEAD_PROJECT;PMNAME=LINK_ID.NAME;' +
      'PMDESC=LINK_ID.DESCRIPTION;PMSNR=LINK_ID.PM_SNR;PMSNRDESC=LINK_ID.PM_SNR_DESCRIPTION;PMINDEX=PM_ACTIVITY_ID.INDEX_ZI' +
      ';PMICON=LINK_ID.CLIENTICON;PM_PLANNER_NAME=PM_CONTACT_EXTPLANNER.TEXT;PM_METROLOGIST_NAME=PM_CONTACT_EXTMETROLOGIST.TEXT;BMNR=LINK_ID.PM_BM_NR';
    const aliasBm =
      'SNR=TEILE_OBJECT_ID.TEXT;ACTIVITYICON=PSETYP_ID.CLIENTICON;' +
      'TERMINA=PARENT.MEILENSTEIN_CONT_ID.CHILD[NAME=A-TER].MS_DATUM;CALC_OPEN=OBJECT_ID.CALC_COUNT_OPEN_DELIVERY' +
      ';WERKZEUGART=PSE_WERKZEUGART_ID.TEXT;AUSFUEHRUNG=PSE_AUSFUEHRUNG.DESCRIPTION;PSETYPGUID=PSETYP_ID.GUID' +
      ';DWS_CHANGE_DOCUNAME=DWS_CHANGE_DOCU_ID.NAME;' +
      'IS_OMITTED=$OR(PR_STATUS_ID.GUID="130e6902-2c07-11b2-80a4-1b2cfea31215",' +
      'PARENT.PR_STATUS_ID.GUID="130e6902-2c07-11b2-80a4-1b2cfea31215");';
    const aliasTl =
      'SNR=TEILE_OBJECT_ID.TEXT;ACTIVITYICON=PSETYP_ID.CLIENTICON;' +
      'TERMINA=PARENT.MEILENSTEIN_CONT_ID.CHILD[NAME=A-TER].MS_DATUM;CALC_OPEN=OBJECT_ID.CALC_COUNT_OPEN_DELIVERY' +
      ';PSETYPGUID=PSETYP_ID.GUID;DWS_CHANGE_DOCUNAME=DWS_CHANGE_DOCU_ID.NAME;' +
      'IS_OMITTED=$OR(PR_STATUS_ID.GUID="130e6902-2c07-11b2-80a4-1b2cfea31215",' +
      'PARENT.PR_STATUS_ID.GUID="130e6902-2c07-11b2-80a4-1b2cfea31215");HAS_MEASUREMENT_PROTOCOL=' +
      '$SIZE($FILTER(DOKUMENTCONTAINER_ID.CHILDREN(PATH=b516f108-27fa-11b2-800a-b390cd5bbe84),' +
      'DOKUMENTART_ID.GUID="e9d0e32e-2bd1-11b2-8005-739a5d40590d")) > 0';
    return this.actions.pipe(
      ofType(OrdersActions.LOAD_OVERVIEW),
      switchMap((action) => {
        const params = {
          overviewType: action.overviewType,
          order: this.ordersService.getPurchaseOrder(
            action.orderId,
            aliasOrder,
          ),
        };
        return of(params);
      }),
      exhaustMap((params) => {
        return params.order.pipe(
          exhaustMap((order) => {
            switch (params.overviewType) {
              case 'pm':
                return this.getPmRequests(order, aliasPm).pipe(
                  map((result) => {
                    return OrdersActions.LOAD_OVERVIEW_SUCCESS({
                      overview: {
                        pmPositions: result.positions,
                        orderStatusIcons: result.icons,
                        order,
                      },
                    });
                  }),
                );
              case 'int':
                return this.getInternalRequests(order, aliasTp, aliasBm).pipe(
                  map((result) => {
                    return OrdersActions.LOAD_OVERVIEW_SUCCESS({
                      overview: {
                        bmPositions: result.bm,
                        tpPositions: result.view,
                        orderStatusIcons: result.icons,
                        order,
                      },
                    });
                  }),
                );
              case 'ext':
                return this.getExternalRequests(order, aliasTl, aliasBm).pipe(
                  map((result) => {
                    return OrdersActions.LOAD_OVERVIEW_SUCCESS({
                      overview: {
                        order,
                        bmPositions: result.bm,
                        tlPositions: result.view,
                        orderStatusIcons: result.icons,
                      },
                    });
                  }),
                );
            }
          }),
        );
      }),
    );
  });

  private getExternalRequests(
    order: ProleisObject,
    aliasTl: string,
    aliasBm: string,
  ): Observable<any> {
    return forkJoin({
      view: this.loadPositions(order.OBJECT_ID, aliasTl, 'tl'),
      bm: this.loadPositions(order.OBJECT_ID, aliasBm, 'bm'),
      icons: this.getIcons(order),
    });
  }

  private getInternalRequests(
    order: ProleisObject,
    aliasTp: string,
    aliasBm: string,
  ): Observable<any> {
    return forkJoin({
      view: this.loadPositions(order.OBJECT_ID, aliasTp, 'tp'),
      bm: this.loadPositions(order.OBJECT_ID, aliasBm, 'bm'),
      icons: this.getIcons(order),
    });
  }

  private getPmRequests(order: ProleisObject, aliasPm: string) {
    return forkJoin({
      positions: this.loadPositions(order.OBJECT_ID, aliasPm, 'pm'),
      icons: this.getIcons(order),
    });
  }

  private getIcons(order: ProleisObject): Observable<any> {
    return this.imageService.getIconUrls(order.LIEFERSTATUS_ICON);
  }

  $filterOverview = createEffect(() => {
    return this.actions.pipe(
      ofType(OrdersActions.FILTER_OVERVIEW),
      switchMap((action) => {
        if (action.filter.length > 0) {
          return action.overview$.pipe(
            map((overview) => {
              overview.bmPositions = overview.bmPositions.filter((pos) =>
                this.filterPositions(pos, action.filter),
              );
              overview.tlPositions = overview.tlPositions.filter((pos) =>
                this.filterPositions(pos, action.filter),
              );
              overview.tpPositions = overview.tpPositions.filter((pos) =>
                this.filterPositions(pos, action.filter),
              );
              return OrdersActions.FILTER_OVERVIEW_SUCCESS({
                filteredOverview: overview,
              });
            }),
          );
        } else {
          return action.overview$.pipe(
            map((overview) =>
              OrdersActions.FILTER_OVERVIEW_SUCCESS({
                filteredOverview: overview,
              }),
            ),
          );
        }
      }),
    );
  });

  loadPositions(
    orderId: string,
    aliasFields: string,
    type: string,
  ): Observable<ProleisObject[]> {
    return this.suppliersService.getPositions(
      orderId,
      null,
      type,
      null,
      aliasFields,
    );
  }

  filterPositions(pos: ProleisObject, filter: string): boolean {
    return (
      pos.NAME.toLowerCase().includes(filter.toLowerCase()) ||
      pos.TEXT.toLowerCase().includes(filter.toLowerCase())
    );
  }
}
